import LocalizationStore from '../Stores/LocalizationStore'
import { AjvError } from 'react-jsonschema-form'
import { ReactNode } from 'react'
import ReactTable, { RowInfo } from 'react-table'
import { toJS } from 'mobx'
import DateTimeHelper from '../Helpers/DateTimeHelper'
import * as React from 'react'
import * as _ from 'lodash'
import ExternalDataColumnsLink from '../Views/PartialViews/ExternalData/ExternalDataViews/ExternalDataColumnsLink'

const ls = LocalizationStore.getInstance()

export function getExternalDataByPhoneFormSchema(): any {
    return {
        'title': ls.t!('Get external data by phone'),
        'type': 'object',
        'required': [
            'phoneNumber',
        ],
        'properties': {
            'phoneNumber': {
                'title': ls.t('Enter phone number'),
                'type': 'string'
            }
        }
    }
}

export const UIGetExternalDataByPhoneFormSchema = {
    'phoneNumber': {
        // 'ui:autofocus': true
    }
}

export function transformErrors(errors: Array<AjvError>) {
    return errors.map((error: AjvError) => {
        if (error['property'] === '.phoneNumber') {
            // TODO: just example
            // error['message'] = ls.t('Логин должен содержать не меньше 5 символов')
        }
        return error
    })
}

export class ExternalData {
    constructor() {
        this.creditInfoItems = new Array<ExternalCreditData>()
    }

    creditInfoItems: Array<ExternalCreditData>
}

export class ExternalCreditData {
    creditNumber: string
    fullName: string
    passportNumber: string
    client: ExternalDataClient
    products: Array<ExternalDataProduct>
    payments: Array<ExternalDataPayment>
    totalDueAmount: number
    currentDueAmount: number
    totalDpd: string
    creditStatus: string
    creditStatusNode: ReactNode
    creditDuration: string
    creditAmount: string
    dataSourceName: string
    declineReason: string
    phoneComment: string
    prepaymentSum: string
    paymentSchedule: Array<ExternalPaymentScheduleItem>
    affiliateId?: number
    affiliate: string
    staffMemberId: number
    staffMember: string
    date: string
    source: string
    affiliateData: string
    staffMemberData: string
    creditTotalSum: number
    currentDebtWithPenalty: number
}

export class ExternalPaymentScheduleItem {
    balance: number
    credit: string
    creditid: number
    ddate: string
    id: number
    pDebit: number
    pbalance: number
    pvalue: number
    ss: number
    tenpercentMonth: string
    value: number
}

export class ExternalDataClient {
    id: string
    firstName: string
    middleName: string
    lastName: string
    fullName: string
    passportNumber: string
    registrationAddress: string
    actualAddress: string
    mobilePhone: string
    homePhone: string
    workPhone: string
    otherPhone: string
    income: string
    rStatus: string
    birthday: string
    cardno: string
    clientCode: string
    standartAccountNumber: string
}

export class ExternalDataProduct {
    id: string
    name: string
    brand: string
    model: string
    serialNumber: string | null
    quantity: string
    price: string
    status: string
    lastUpdateDate: string
    registrationDate: string
}

export class ExternalDataPayment {
    id: string
    paymentDate: string
    amount: string
    checkNumber: string
    paymentType: string
}

export class ExternalGovPhoneData {
    phone: string
    fullName: string
    street: string
    phoneType: string
    debt: string
    currentDebt: string
    phoneFee: string
    longDistantCallsFee: string
    registrationOfCommunicationServices: string
    azDataCom: string
    bakinterNet: string
}

export class ExternalGovPinData {
    pin: string
    fullName: string
    firstName: string
    lastName: string
    middleName: string
    dateOfBirth: string
    passportSeria: string
    passportNumber: number
    passportGivenBy: string
    dateOfIssue: string
    passportExpires: string
    city: string
    address: string
}

export function getExternalDataStatusTextForList(status: string) {
    const localizationStore = LocalizationStore.getInstance()

    switch (status) {
        case 'Declined':
            return localizationStore!.t!('Declined')
        case 'Accepted':
            return localizationStore!.t!('Accepted')
        case 'bagli':
            return localizationStore!.t!('bagli')
        case 'problemli':
            return localizationStore!.t!('problemli')
        case 'aktiv':
            return localizationStore!.t!('aktiv')
        default: return `status ${status}`
    }
}

export function getQuestionnaireStatusClass(status: string): string {
    switch (status) {
        case 'Declined':
            return 'cancel-status'
        case 'Accepted':
            return 'accepted-status'
        case 'bagli':
            return 'done-status' // TODO: change class'
        case 'problemli':
            return 'problem'
        case 'aktiv':
            return 'active-credit'
        default: return ''
    }
}

export function getProductsColumns(): any {
    return [
        {
            Header: ls!.t('id'),
            maxWidth: 150,
            minWidth: 100,
            accessor: 'id'
        },
        {
            Header: ls!.t('name'),
            maxWidth: 150,
            minWidth: 100,
            accessor: 'name'
        },
        {
            Header: ls!.t('brand'),
            maxWidth: 150,
            minWidth: 100,
            accessor: 'brand'
        },
        {
            Header: ls!.t('model'),
            maxWidth: 150,
            minWidth: 100,
            accessor: 'model'
        },
        {
            Header: ls!.t('serialNumber'),
            maxWidth: 150,
            minWidth: 100,
            accessor: 'serialNumber'
        },
        {
            Header: ls!.t('quantity'),
            maxWidth: 150,
            minWidth: 100,
            accessor: 'quantity'
        },
        {
            Header: ls!.t('price'),
            maxWidth: 150,
            minWidth: 100,
            accessor: 'price'
        },
        {
            Header: ls!.t('status'),
            maxWidth: 150,
            minWidth: 100,
            accessor: 'status'
        }
    ]
}

export function getPaymentsColumns(): any {
    return [
        {
            Header: ls!.t('paymentDate'),
            maxWidth: 150,
            minWidth: 100,
            accessor: 'paymentDate'
        },
        {
            Header: ls!.t('id'),
            maxWidth: 150,
            minWidth: 100,
            accessor: 'id'
        },
        {
            Header: ls!.t('amountSum'),
            maxWidth: 150,
            minWidth: 100,
            accessor: 'amount'
        },
        {
            Header: ls!.t('checkNumber'),
            maxWidth: 150,
            minWidth: 100,
            accessor: 'checkNumber'
        },
        {
            Header: ls!.t('paymentType'),
            maxWidth: 300,
            minWidth: 250,
            accessor: 'paymentType'
        }
    ]
}

export function getExternalDataColumns(): any {
    return [
        {
            Header: ls!.t(''),
            maxWidth: 60,
            minWidth: 60,
            accessor: 'creditNumber',
            filterable: false,
            Cell: (e: any) => <ExternalDataColumnsLink creditNumber={e.value} />
        },
        {
            Header: ls!.t('creditNumberForList'),
            maxWidth: 60,
            minWidth: 60,
            accessor: 'creditNumber'
        },
        {
            Header: ls!.t('Full name'),
            accessor: 'fullName',
            maxWidth: 130,
            minWidth: 100,
            filterMethod: (filter: any, row: any) => {
                if (row.fullName && row.fullName) {
                    return -1 !== row.fullName.toUpperCase().indexOf(filter.value.toUpperCase())
                } else {
                    return false
                }
            }
        },
        {
            Header: ls!.t('passport'),
            accessor: 'passportNumber',
            maxWidth: 60,
            minWidth: 60,
            filterMethod: (filter: any, row: any) => {
                if (row.passportNumber) {
                    return -1 !== row.passportNumber.toUpperCase().indexOf(filter.value.toUpperCase())
                } else {
                    return false
                }
            }
        },
        {
            Header: ls!.t('creditStatus'),
            accessor: 'creditStatusNode',
            maxWidth: 85,
            minWidth: 85,
            filterMethod: (filter: any, row: any) =>
                -1 !== row[filter.id].props.children
                    .toUpperCase()
                    .indexOf(filter.value.toUpperCase())
        },
        {
            Header: ls!.t('declineReason'),
            maxWidth: 60,
            minWidth: 60,
            accessor: 'declineReason'
        },
        {
            Header: ls!.t('creditDuration'),
            accessor: 'creditDuration',
            maxWidth: 85,
            minWidth: 85,
            className: 'bold'
        },
        {
            Header: ls!.t('creditTotalSum'),
            accessor: 'creditTotalSum',
            maxWidth: 90,
            minWidth: 90,
            className: 'bold'
        },
        {
            Header: ls!.t('totalDueAmount'),
            accessor: 'totalDueAmount',
            maxWidth: 50,
            minWidth: 50,
            className: 'bold',
            filterMethod: (filter: any, row: any) => {
                if (row && row.totalDueAmount) {
                    return -1 !== row.phoneComment.toUpperCase().indexOf(filter.value.toUpperCase())
                } else {
                    return false
                }
            }
        },
        {
            Header: ls!.t('currentDueAmount'),
            accessor: 'currentDueAmount',
            maxWidth: 50,
            minWidth: 40,
            className: 'bold'
        },
        {
            Header: ls!.t('currentDebtWithPenalty'),
            accessor: 'currentDebtWithPenalty',
            maxWidth: 100,
            minWidth: 100,
            className: 'bold'
        },
        {
            Header: ls!.t('totalDpd'),
            accessor: 'totalDpd',
            maxWidth: 50,
            minWidth: 40,
            className: 'bold',
        },
        {
            Header: ls!.t('MobilePhone'),
            accessor: 'client.mobilePhone',
            maxWidth: 70,
            minWidth: 70
        },
        {
            Header: ls!.t('registrationAddress'),
            accessor: 'client.registrationAddress',
            maxWidth: 100,
            minWidth: 100
        },
        {
            Header: ls!.t('birthday'),
            accessor: 'client.birthday',
            maxWidth: 100,
            minWidth: 100
        },
        {
            Header: ls!.t('phoneComment'),
            accessor: 'phoneComment',
            maxWidth: 90,
            minWidth: 90
        },
        {
            Header: ls!.t('affiliate'),
            accessor: 'affiliateData',
            maxWidth: 90,
            minWidth: 90
        },
        {
            Header: ls!.t('staffMember'),
            accessor: 'staffMemberData',
            maxWidth: 90,
            minWidth: 90
        },
        {
            Header: ls!.t('dateCreateCredit'),
            accessor: 'date',
            maxWidth: 100,
            minWidth: 100
        },
        {
            Header: ls!.t('source'),
            accessor: 'source',
            maxWidth: 60,
            minWidth: 60
        },
        // {
        //     Header: ls!.t('registrationAddress'),
        //     accessor: 'client.registrationAddress',
        //     maxWidth: 100,
        //     minWidth: 100
        // },
        {
            Header: ls!.t('actualAddress'),
            accessor: 'client.actualAddress',
            maxWidth: 100,
            minWidth: 100
        },
        // {
        //     Header: ls!.t('MobilePhone'),
        //     accessor: 'client.mobilePhone',
        //     maxWidth: 100,
        //     minWidth: 100
        // },
        {
            Header: ls!.t('HomePhone'),
            accessor: 'client.homePhone',
            maxWidth: 70,
            minWidth: 70
        },
        {
            Header: ls!.t('WorkPhone'),
            accessor: 'client.workPhone',
            maxWidth: 60,
            minWidth: 60
        },
        {
            Header: ls!.t('OtherPhone'),
            accessor: 'client.otherPhone',
            maxWidth: 60,
            minWidth: 60
        },
        {
            Header: ls!.t('status'),
            accessor: 'client.rStatus',
            maxWidth: 50,
            minWidth: 50
        },
        {
            Header: ls!.t('income'),
            accessor: 'client.income',
            maxWidth: 50,
            minWidth: 50
        },
        // {
        //     Header: ls!.t('birthday'),
        //     accessor: 'client.birthday',
        //     maxWidth: 100,
        //     minWidth: 100
        // },
        {
            Header: ls!.t('cardno'),
            accessor: 'client.cardno',
            maxWidth: 60,
            minWidth: 60
        }
    ]
}

export function getExternalDataColumnsGroupedByClient(): any {
    return [
        {
            Header: ls!.t('id'),
            maxWidth: 150,
            minWidth: 90,
            accessor: 'client.id'
        },
        {
            Header: ls!.t('Name'),
            maxWidth: 400,
            minWidth: 90,
            accessor: 'client.firstName'
        },
        {
            Header: ls!.t('surname'),
            maxWidth: 400,
            minWidth: 90,
            accessor: 'client.lastName'
        },
        {
            Header: ls!.t('middleName'),
            maxWidth: 400,
            minWidth: 90,
            accessor: 'client.middleName'
        },
        {
            Header: ls!.t('passportSeria'),
            maxWidth: 400,
            minWidth: 90,
            accessor: 'client.passportNumber'
        },
        {
            Header: ls!.t('MobilePhone'),
            accessor: 'client.mobilePhone',
            maxWidth: 400,
            minWidth: 90
        },
        {
            Header: ls!.t('HomePhone'),
            accessor: 'client.homePhone',
            maxWidth: 400,
            minWidth: 90
        },
        {
            Header: ls!.t('WorkPhone'),
            accessor: 'client.workPhone',
            maxWidth: 400,
            minWidth: 90
        },
        {
            Header: ls!.t('OtherPhone'),
            accessor: 'client.otherPhone',
            maxWidth: 400,
            minWidth: 90
        },
        {
            Header: ls!.t('birthday'),
            maxWidth: 200,
            minWidth: 90,
            accessor: 'client.birthday'
        }
    ]
}

export function getPaymentScheduleColumns() {
    return [
        {
            Header: ls!.t('paymentDate'),
            maxWidth: 150,
            minWidth: 90,
            accessor: 'ddate'
        },
        {
            Header: ls!.t('id'),
            maxWidth: 150,
            minWidth: 90,
            accessor: 'id'
        },
        {
            Header: ls!.t('amountSum'),
            maxWidth: 150,
            minWidth: 90,
            accessor: 'pvalue'
        }
        ,
        {
            Header: ls!.t('Debt in the current month'),
            maxWidth: 150,
            minWidth: 90,
            accessor: 'pbalance'
        }
        ,
        {
            Header: ls!.t('Debt'),
            maxWidth: 150,
            minWidth: 90,
            accessor: 'balance'
        }
    ]
}

export function createSimpleStub(data: Array<ExternalCreditData>) {
    let tableData = toJS(data)
    tableData.map(e => {
        try {
            e.creditNumber = e.creditNumber
            e.creditStatusNode = (
                <a className={getQuestionnaireStatusClass(e.creditStatus)}>
                    {getExternalDataStatusTextForList(e.creditStatus)}
                </a>
            )
            e.fullName = e.client.lastName + ' ' + e.client.firstName + ' ' + e.client.middleName
            e.creditDuration = e.creditDuration
            e.declineReason = e.declineReason
            e.passportNumber = e.client.passportNumber
            e.phoneComment = e.phoneComment
            e.totalDueAmount = Math.floor(e.totalDueAmount * 100) / 100
            e.totalDpd = e.totalDpd
            e.payments = toJS(e.payments)
            e.payments.map(p => {
                p.paymentDate = DateTimeHelper.formatDateForList(p.paymentDate)
            })
            e.affiliateData = `${e.affiliate} (${ls.t('id')} ${e.affiliateId})`
            e.staffMemberData = `${e.staffMember} (${ls.t('id')} ${e.staffMemberId})`

            try {
                e.creditTotalSum = _.sumBy(e.products, 'price')
                e.currentDebtWithPenalty =
                    _.round(e.creditTotalSum + e.totalDueAmount - _.sumBy(e.payments, 'amount'), 1)
                e.currentDueAmount = _.round(
                    e.totalDueAmount -
                    _.sumBy(
                        e.payments.filter(x => {
                            return x.paymentType === 'Cerime' || x.paymentType === 'Borc_azaltma (Cerime-den)'
                        }),
                        'amount'),
                    1)
            } catch {
                e.creditTotalSum = 0
                e.currentDebtWithPenalty = 0
            }

            return e
        } catch {
            return []
        }

    }
    )
    return tableData.filter(x => x)
}

export function createFilteredStub(data: Array<ExternalCreditData>) {
    let tableData = toJS(data)

    tableData.map(e => {
        try {
            e.creditNumber = e.creditNumber
            e.creditStatusNode = (
                <a className={getQuestionnaireStatusClass(e.creditStatus)}>
                    {getExternalDataStatusTextForList(e.creditStatus)}
                </a>
            )
            e.fullName = e.client.lastName + ' ' + e.client.firstName + ' ' + e.client.middleName
            e.creditDuration = e.creditDuration
            e.declineReason = e.declineReason
            e.passportNumber = e.client.passportNumber
            e.phoneComment = e.phoneComment
            e.totalDueAmount = Math.floor(e.totalDueAmount * 100) / 100
            e.totalDpd = e.totalDpd
            e.payments = toJS(e.payments)
            e.payments.map(p => {
                p.paymentDate = DateTimeHelper.formatDateForList(p.paymentDate)
            })
            e.affiliateData = `${e.affiliate} (${ls.t('id')} ${e.affiliateId})`
            e.staffMemberData = `${e.staffMember} (${ls.t('id')} ${e.staffMemberId})`

            try {
                e.creditTotalSum = _.sumBy(e.products, 'price')
                e.currentDebtWithPenalty =
                    _.round(e.creditTotalSum + e.totalDueAmount - _.sumBy(e.payments, 'amount'), 1)
                e.currentDueAmount =
                    _.round(
                        e.totalDueAmount -
                        _.sumBy(
                            e.payments.filter(x => {
                                return x.paymentType === 'Cerime' || x.paymentType === 'Borc_azaltma (Cerime-den)'
                            }),
                            'amount'),
                        1)
            } catch {
                e.creditTotalSum = 0
                e.currentDebtWithPenalty = 0
            }

            return e
        } catch {
            return []
        }
    }
    )

    return {
        stubAllCreditsSky: tableData.filter(x => 'Sky' === x.dataSourceName),
        stubAllCreditsMagnit: tableData.filter(x => 'Magnit' === x.dataSourceName),
        stubDeclinedSky: tableData
            .filter(x => 'Sky' === x.dataSourceName && 'Declined' === x.creditStatus),
        stubDeclinedMagnit: tableData
            .filter(x => 'Magnit' === x.dataSourceName && 'Declined' === x.creditStatus),
        stubAcceptedSky: tableData
            .filter(x => 'Sky' === x.dataSourceName && 'Accepted' === x.creditStatus),
        stubAcceptedMagnit: tableData
            .filter(x => 'Magnit' === x.dataSourceName && 'Accepted' === x.creditStatus),
        stubClosedSky: tableData
            .filter(x => 'Sky' === x.dataSourceName && 'bagli' === x.creditStatus),
        stubClosedMagnit: tableData
            .filter(x => 'Magnit' === x.dataSourceName && 'bagli' === x.creditStatus),
        stubFraudSky: tableData
            .filter(x => 'Sky' === x.dataSourceName && 'Fraud' === x.creditStatus),
        stubFraudMagnit: tableData
            .filter(x => 'Magnit' === x.dataSourceName && 'Fraud' === x.creditStatus),

        stubSortedByCreditorSky: _.chain(tableData.filter(x => 'Sky' === x.dataSourceName))
            .groupBy('client.id')
            .map((value, key) => {
                return { client: value[0].client, creditInfoItems: value }
            })
            .value(),

        stubSortedByCreditorMagnit: _.chain(tableData.filter(x => 'Magnit' === x.dataSourceName))
            .groupBy('client.id')
            .map((value, key) => {
                return { client: value[0].client, creditInfoItems: value }
            })
            .value(),
        stubStandart: tableData
            .filter(x => 'Standart' === x.dataSourceName),
    }
}

// export function getSubInfo(rowInfo: RowInfo): React.ReactNode {
//     return <ExternalDataDetailsView externalCreditData={rowInfo['original']} className='fit-content'/>
// }

export function getSubInfoGroupedByClient(rowInfo: RowInfo): React.ReactNode {

    let d = rowInfo.original.creditInfoItems as Array<ExternalCreditData>
    var expanded = d.map((x, i) => {
        return {
            i: true
        }
    })
    return (
        <div className="externalDataGroupedByClientInfoItem fit-content">
            <ReactTable
                defaultExpanded={expanded}
                data={createSimpleStub(rowInfo.original.creditInfoItems)}
                columns={getExternalDataColumns()}
                // SubComponent={getSubInfo}
                defaultPageSize={5}
                className="-striped -highlight"
                noDataText={ls.t('No data text')}
                filterable={false}
                previousText={ls.t('Previous')}
                nextText={ls.t('Next')}
                pageText={ls.t('Page')}
                ofText={ls.t('of')}
            />
        </div>
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/ExternalData.tsx